module.exports = __webpack_public_path__ + "img/pensavo.3837962b.jpg";